import { Injectable } from '@angular/core';
import { CART , AdpCustomer ,attributesMap,attributesPropertiesMap, RoutingInfo, loginUserInfo, supplierInfor} from '../providers/data';
import { CartPage } from '../pages/cart/cart';
import { Headers, RequestOptions } from '@angular/http';
import {IMAGES_BASE_URL} from './config';

import { Storage } from '@ionic/storage';


import {DomSanitizer} from '@angular/platform-browser';
import { CustomerCarts } from './user-cart-provider/user-carts';
import { ToastController } from 'ionic-angular';
import {Constants} from './config';
@Injectable()
export class CartManager {



public getCust:any ;
public getCusttt:any = " UD";
constructor(private storage:Storage,private sanitizer:DomSanitizer, public toastCtrl:ToastController){

}
  setCustomerShippingCost(cost){
    CART.customerShippingCost = cost;
  }

  getCustomerShippingCost(){
    return CART.customerShippingCost;
  }


setCustomer(customer){

  if(CART.customer == null){

  CART.customer = customer;
  }else{
    this.clearCartProducts();
    CART.customer = customer;
  }
  //alert(JSON.stringify(CART));
}



setSalesPerson(user){
  CART.user = user;
  //alert(JSON.stringify(CART));
}

placeOrder(){
}

clearCart(){
  CART.items = [];
  //alert(JSON.stringify(CART));
}


// addToCartNew(product) {
//       // alert("product.productType : " + product.productType + " product.qtyONHAND : " + product.qtyONHAND + " product.quantity " + product.quantity);
//
//       if(product.productType === 0){
//         // alert("product.productType === 0");
//         if(Number(product.minOrder)){
//           if (Number(product.minOrder) != 0 && Number(product.quantity) < Number(product.minOrder)) {
//             product.quantity = Number(product.minOrder);
//           } else if(Number(product.quantity) > Number(product.minOrder)){
//
//           }else{
//              if(!Number(product.quantity)){
//                product.quantiry = product.minOrder;
//              }
//           }
//         }else if(!Number(product.minOrder)){
//           if(Number(product.quantity)<=1){
//             product.quantity = 1;
//           }
//         }
//
//         CART.items.push(product);
//         this.persistOrderLocal();
//
//         let toast = this.toastCtrl.create({
//           message: "Product added to cart!",
//           duration: 2000,
//           position: 'middle'
//           });
//           // toast.present();
//
//        }else if(product.productType === 1 && product.qtyONHAND > 0){
//         // if((Constants.IntelliStockRunningIn === "BROWSER" || Constants.IntelliStockRunningIn === "APP")){
//           product.quantity = product.qtyONHAND;
//           // alert("quantity.. " + product.quantity + " productType " + product.productType + " constant " + Constants.IntelliStockRunningIn);
//         // }
//       //   else{
//       //   // alert("product.productType === 1 && product.qtyONHAND > 0");
//       //   if(Number(product.minOrder)){
//       //     if (Number(product.minOrder) != 0 && Number(product.quantity) < Number(product.minOrder)) {
//       //       product.quantity = Number(product.minOrder);
//       //     } else if(Number(product.quantity) > Number(product.minOrder)){
//
//       //     }else{
//       //        if(!Number(product.quantity)){
//       //          product.quantiry = product.minOrder;
//       //        }
//       //     }
//       //   }else if(!Number(product.minOrder)){
//       //     if(Number(product.quantity)<=1){
//       //       product.quantity = 1;
//       //     }
//       //   }
//       // }
//         CART.items.push(product);
//         this.persistOrderLocal();
//
//         let toast = this.toastCtrl.create({
//           message: "Product added to cart!",
//           duration: 2000,
//           position: 'middle'
//           });
//           // toast.present();
//
//        }else{
//         let toast = this.toastCtrl.create({
//           message: "This product is not available in inventory!",
//           duration: 2000,
//           position: 'middle'
//           });
//           toast.present();
//        }
//
//       //  if(Number(product.minOrder)){
//       //   if (Number(product.minOrder) != 0 && Number(product.quantity) < Number(product.minOrder)) {
//       //     product.quantity = Number(product.minOrder);
//       //   } else if(Number(product.quantity) > Number(product.minOrder)){
//
//       //   }else{
//       //      if(!Number(product.quantity)){
//       //        product.quantiry = product.minOrder;
//       //      }
//       //   }
//       // }else if(!Number(product.minOrder)){
//       //   if(Number(product.quantity)<=1){
//       //     product.quantity = 1;
//       //   }
//       // }
//
//       // CART.items.push(product);
//       // this.persistOrderLocal();
// }

setLoginUserInfo(userName, userCountry, email, firstName, lastName, password, phone){
  loginUserInfo.userName = userName;
  loginUserInfo.userCountry = userCountry;
  loginUserInfo.email = email;
  loginUserInfo.firstName = firstName;
  loginUserInfo.lastName = lastName;
  loginUserInfo.password = password;
  loginUserInfo.phone = phone;
}

getLoginUserCountry(){
  return loginUserInfo.userCountry;
}

getLoginUserName(){
  return loginUserInfo.userName;
}
// addProductToCart(product) {
//
//      var index= CART.items.map(function(x) {return x.id; }).indexOf(product.id);
//       if (index != -1) {
//
//           CART.items[index].quantity++;
//           this.persistOrderLocal();
//       } else {
//
//         // if((Constants.IntelliStockRunningIn === "BROWSER" || Constants.IntelliStockRunningIn === "APP") && product.productType === 1){
//         //   product.quantity = product.qtyONHAND;
//         //   // alert("quantity.. " + product.quantity + " productType " + product.productType + " constant " + Constants.IntelliStockRunningIn);
//         // }
//         // else{
//           // alert("else");
//           if (Number(product.minOrder) != 0) {
//             product.quantity = Number(product.minOrder);
//           } else {
//             product.quantity = 1;
//           }
//         // }
//           this.addToCartNew(product);
//       }
//       //alert(JSON.stringify(CART));
//   }

  // update Cart
  // updateCartNew(product) {
  //
  //   if(Number(product.quantity) < Number(product.minOrder)){
  //     if (Number(product.minOrder) != 0) {
  //       if (Number(product.quantity) != 0) {
  //         product.quantity = Number(product.quantity);
  //       } else {
  //         product.quantity = 1;
  //       }
  //     } else {
  //       product.quantity = 1;
  //     }
  //   }
  //
  //
  //    var index= CART.items.map(function(x) {return x.id; }).indexOf(product.id);
  //     if (index != -1) {
  //         //CART.items[index].quantity++;
  //     } else {
  //
  //         this.addToCartNew(product);
  //     }
  //     this.persistOrderLocal();
  //     //alert(JSON.stringify(CART));
  // }
  // Remove One
  // removeOneNew(product) {
  //   var index= CART.items.map(function(x) {return x.id; }).indexOf(product.id);
  //     if (index != -1) {
  //       if(CART.items[index].quantity > Number(product.minOrder)){
  //         CART.items[index].quantity--;
  //         this.persistOrderLocal();
  //       }else{
  //         CART.items[index].quantity = 0;
  //         this.removeNew(index);
  //
  //       }
  //
  //     }
  // }

  // Remove All
  // removeAll(product) {
  //   var index= CART.items.map(function(x) {return x.id; }).indexOf(product.id);
  //     if (index != -1) {
  //       if(CART.items[index].quantity >= 1){
  //         CART.items[index].quantity = 0;
  //       }
  //       }
  //       this.persistOrderLocal();
  //     }


  // Remove Item
  // removeNew(index: number): void {
  //
  //   CART.items.splice(index, 1);
  //   this.persistOrderLocal();
  // }

  deleteProductFromCart(product){
    this.removeAll(product);
    var index= CART.items.map(function(x) {return x.id; }).indexOf(product.id);
      if (index != -1) {
        this.removeNew(index);
      }
  }
  setSupplierUuid(uuid){
    supplierInfor.uuid = uuid
  }

  setSupplierCountry(country){
    supplierInfor.country = country;
    // })
  }


  getSupplierUuid(){
      return supplierInfor.uuid

  }
  getSupplierCountry(){
      return supplierInfor.country
  }



  setLoggedInUserEmail(email){
    loginUserInfo.email = email;
    // })
  }


  getLoggedInUserEmail(){
    return loginUserInfo.email

  }

  genrateOrder(status, shippingCharges){
    //alert(JSON.stringify(CART));
   let total = 0;
  let orderProducts = [];
  let expectedShipmentDate = CART.shipDate;
  for(let item of CART.items){

    if(this.discountCheck(item.discountPrice)){
       total =  total + (Number(item.discountPrice) * Number(item.quantity));
     }else{
     total =  total + (Number(item.price) * Number(item.quantity));
     }

    var orderDetailDTOs: any = {

       "productsDTO":item,
       "quantity": item.quantity,
       "expectedShipmentDate": expectedShipmentDate,
       "attributeSearch":item.attributeSearch
     };

     orderProducts.push(orderDetailDTOs);
  }

  if(CART.customer.locationsDTOs.length>0){
    for(let locationId in CART.customer.locationsDTO){
      CART.customer.locationsDTO[locationId].createdAt = "";
      CART.customer.locationsDTO[locationId].updatedAt = "";
    }
  }

  CART.customer.customerJson = "";
  let sendMailTo = [];
    sendMailTo.push(this.getLoggedInUserEmail() + "-buyer");

    let salesChannel = "";
    if(Constants.isWebstore === true){
      salesChannel = "B2B Store";
    }else {
      salesChannel = "B2B Sales Rep"
    }

  let order = {
    "id":CART.orderId,
    "orderTitle": this.getOrderTitle(),
    "salesManId":CART.user.id,
    "orderMessage":CART.orderMessage,
    "customerOrderNumber":CART.customerOrderNumber,
    "expectedShipmentDate": CART.expectedShipmentDate,
    "totalAmount":""+total.toFixed(2),
    "shippingCost" : shippingCharges,
    "totalTexAmount":"10",
    "orderStatus":status,
    "customerDTO":CART.customer,
    "orderDetailDTOs": orderProducts,
    "shippingServiceName":CART.shippingServiceName,
    "shippingServiceValue":CART.shippingServiceId,
    "sendMailTo" : sendMailTo,
    "salesChannel" : salesChannel,
    "paymentType"  : "cod"
        };
    //this.gVLogger.log(JSON.stringify(order));

        return order;

  }

  orderShipment(status, cart, orderForShipment, shipmentNo, shipmentDate){
    let userDetail = this.getSalesPerson();
   let total = 0;
  let orderProducts = [];
  let expectedShipmentDate = cart.shipDate;
  for(let item of cart.items){

    if(this.discountCheck(item.discountPrice)){
       total =  total + (Number(item.discountPrice) * Number(item.quantity));
     }else{
     total =  total + (Number(item.price) * Number(item.quantity));
     }


     for(let location of item.productLocationsDTO){
       location.shippedQuantity = location.availableQuantity;
       let date = new Date(location.productInventoryReceivedDate);
       location.productInventoryReceivedDate = date;
     }

    var orderDetailDTOs: any = {

       "productsDTO":item,
       "quantity": item.quantity,
       "expectedShipmentDate": expectedShipmentDate,
       "attributeSearch":item.attributeSearch
     };
    // }

     // if(status == 2){
     //   orderDetailDTOs.odId = this.getOdId();
     // }
    for(let prod of item.productInventoryLocationsDTO)
      if(prod.status === 1){
        orderProducts.push(orderDetailDTOs);
        break;
      }
     // orderProducts.push(orderDetailDTOs);
  }


  cart.customer.customerJson = "";

  let order = {
    // "userId": userDetail.adpcustomersId,
    // "userName":userDetail.userName,
    // "consumptionCount": orderForShipment.orderDetailDTOs.length,//UD
    "createdAt": orderForShipment.createdAt,
    "id":cart.orderId,
    "orderTitle": cart.orderTitle,
    // "salesManId":cart.user.id,
    "orderMessage":cart.orderMessage,
    "expectedShipmentDate": cart.expectedShipmentDate,
    "totalAmount":""+total.toFixed(2),
    "totalTexAmount":"10",
    "orderStatus":5,
    "customerDTO":cart.customer,
    "orderDetailDTOs": orderProducts,
    "shippingServiceName":cart.shippingServiceName,
    "shippingServiceValue":cart.shippingServiceId,
    "shipmentNo": shipmentNo,
    "plannedShipmentDate": shipmentDate
        };
    //this.gVLogger.log(JSON.stringify(order));

        return order;

  }

  receiveStock(status){
    //alert(JSON.stringify(CART));
   let total = 0;
  let orderProducts = [];
  let expectedShipmentDate = CART.shipDate;

  for(let item of CART.items){

    if(this.discountCheck(item.discountPrice)){
       total =  total + (Number(item.discountPrice) * Number(item.quantity));
     }else{
     total =  total + (Number(item.price) * Number(item.quantity));
     }

    var orderDetailDTOs: any = {

       "productsDTO":item,
       "quantity": item.quantity,
       "expectedShipmentDate": expectedShipmentDate,
       "attributeSearch":item.attributeSearch
     };


     orderProducts.push(orderDetailDTOs);
  }

  if(CART.customer.locationsDTOs.length>0){
    for(let locationId in CART.customer.locationsDTO){
      CART.customer.locationsDTO[locationId].createdAt = "";
      CART.customer.locationsDTO[locationId].updatedAt = "";
    }
  }

  CART.customer.customerJson = "";

  let order = {
    "id":CART.orderId,
    "barCode":CART.orderId,
    "orderTitle": this.getOrderTitle(),
    "salesManId":CART.user.id,
    "orderMessage":CART.orderMessage,
    "expectedShipmentDate": CART.expectedShipmentDate,
    "totalAmount":""+total.toFixed(2),
    "totalTexAmount":"10",
    "orderStatus":status,
    "customerDTO":CART.customer,
    "orderDetailDTOs": orderProducts,
    "shippingServiceName":CART.shippingServiceName,
    "shippingServiceValue":CART.shippingServiceId
        };

        return order;

  }

  clearCartProducts(){
    for(let product of CART.items){
      this.removeAll(product);
    }
    CART.items = [];
  }

getProductsCount(){
  return CART.items.length;
}

 getSalesManId(){
   return CART.user.id;
 }
 getCustomerName(){
   if(CART.customer !=null){

   return CART.customer.name;
   }else{
     return null;
   }
 }

 getSalesPerson(){
   return CART.user;

 }

 getADPCustomerUUID(){
   if(CART.user && CART.user.adpCustomerInfo){
   return CART.user.adpCustomerInfo.uuid;
   }else{
     return "";
   }
 }

 setShipDate(shipDate){
   CART.expectedShipmentDate = shipDate ;
 }
 getShipDate(){
   return CART.expectedShipmentDate;
 }

 setOdId(odId){
   CART.odId = odId;
 }

 getOdId(){
   return CART.odId;
 }

 setItems(productsList){
   CART.items = productsList;
 }
 setOrderId(orderId){
   CART.orderId = orderId ;
 }
 setOrderMessage(orderMessage){
  CART.orderMessage = orderMessage;
 }

  setCustomerOrderNumber(custOrderNum){
    CART.customerOrderNumber = custOrderNum;
  }

  removeCustomerOrderNumber(){
    CART.customerOrderNumber = "";
  }
 getOrderMessage(){
  return CART.orderMessage;
 }

 getExpectedSipDate(){
   return CART.expectedSipDate;
 }

 getItems(){
   return CART.items;
 }


 getCustomerID(){
   if(CART.customer!=null){
     return CART.customer.id;
   }else{
     return false;
   }
 }


 getSelectedCustomer(){
     return CART.customer;
 }

setOrderTitle(orderTitle){
  CART.orderTitle = orderTitle;
}

getOrderTitle(){
  return CART.orderTitle;
}
getOrderId(){
  return CART.orderId;
}

persistOrderLocal(){
 // TODO: Store the list of Cart against their user/sales persons
 let itemQuantityStatus = false;
 for(let product of CART.items){
   if(product.quantity > 0){
     itemQuantityStatus = true;
     break;
   }
 }

 if(Number(CART.items.length) > 0 && itemQuantityStatus){
   this.storage.set(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId(),CART);

 }else{
   this.unPersistOrderLocal();
 }
//this.gVLogger.log(CART);
}
unPersistOrderLocal(){
  this.storage.remove(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());


}

getPersistedOrderLocal(){

  return this.storage.get(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
}

setCartFull(cartTemp){
   CART.items = cartTemp.items;
   CART.orderId = cartTemp.orderId;
   CART.orderMessage = cartTemp.orderMessage;
   CART.customer = cartTemp.customer;
   CART.orderTitle = cartTemp.orderTitle;
  // this.gVLogger.log("Cart Replaced...",cartTemp);
}


discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }

getOrderStatus(){
  return CART.orderStatus;
}

setOrderStatus(status){
  CART.orderStatus = status;
}


removeJunkFromCart(){
  for(let item of CART.items ){
    // this.gVLogger.log("Item: ",item);
    if(item.quantity == 0 || item.quantity == '0'){
      // this.gVLogger.log("Item inner: ",item);
      var index= CART.items.map(function(x) {return x.id; }).indexOf(item.id);
      if (index != -1) {
          if(CART.items[index].quantity >= 1){
            CART.items[index].quantity = 0;
          }
          CART.items.splice(index, 1);
        }
    }
  }
}


makeImageURL(dimensions,item){
  // this.gVLogger.log("imagesDtos" + JSON.stringify( item.productsDTO));
  return  IMAGES_BASE_URL.imageBaseUrl + "/" + this.getADPCustomerUUID() +
  "/products/" +
  dimensions + "/"+
  item.productImagesDTO[0].name+
  "-" +
   dimensions +
   "." +
   item.productImagesDTO[0].extension;
}

makeImageURLByImagesDtoObject(dimensions,productImagesDTO){
  return  IMAGES_BASE_URL.imageBaseUrl + "/" + this.getADPCustomerUUID() +
  "/products/" +
  dimensions + "/"+
  productImagesDTO.name+
  "-" +
   dimensions +
   "." +
   productImagesDTO.extension;
}

makeImageURLFromImage(dimensions,imgObject){
  // http://dev.cdn01.anydatapoint.com/387985DC-FE07-4E46-B3F5-58A6F8152A0F/products/400x400/01015001-400x400.jpg
  return  IMAGES_BASE_URL + this.getADPCustomerUUID() +
  "/products/" +
  dimensions + "/"+
  imgObject.name+
  "-" +
   dimensions +
   "." +
   imgObject.extension;
}

makeNANImageURLFromImage(dimensions){

  // http://dev.cdn01.anydatapoint.com/387985DC-FE07-4E46-B3F5-58A6F8152A0F/products/400x400/01015001-400x400.jpg
  // this.gVLogger.log( "uuuuuuuuuuuuuuuuiiiiiiiiiiiiiiiiiiiiiiiddddddddddddddddddddddddddddddddddddddddddddddddddddd " + IMAGES_BASE_URL + this.getADPCustomerUUID() +
  //   "/products/" +
  //   dimensions + "/"+
  //   "nan"+
  //   "-" +
  //   dimensions +
  //   "." +
  //   "png");
  return  IMAGES_BASE_URL + this.getADPCustomerUUID() +
  "/products/" +
  dimensions + "/"+
  "dummy"+
  "-" +
   dimensions +
   "." +
   "png";
}


setShipingServiceName(name){
  CART.shippingServiceName = name;
}
getShippingServiceName(){
  return CART.shippingServiceName;
}

setShippingServiceId(id){
  CART.shippingServiceId = id;
}
getShippingServiceId(){
return CART.shippingServiceId;
}


setAdpCustomerInfo(adpCustomerInfo){
  AdpCustomer.AdpCustomerInfo = adpCustomerInfo;
}

getAdpCustomerInfo(){
  return AdpCustomer.AdpCustomerInfo;
}


sanitizeUrl(url){
  return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }



  addToAttributeMap(key,value){
    attributesMap[key+""] = ""+value;
  }

  getAttributeValue(key){
    let res = attributesMap[key+""];
    if(res === undefined){
      return "-"
    }else{
      return res;
    }
  }


  addAttributePropertiesMap(key,val){
    attributesPropertiesMap.set(key+"", val);
  }

  getAllAttributesPropertiesMap(){
    return attributesPropertiesMap;
  }

  replaceDoublePipe(str){
    return str.split("||").join(" ");
  }

  ConvertToCSV(objArray) {
    // alert(JSON.stringify(objArray));
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = "";
    for (let index in objArray[0]) {
        //Now convert each value to string and comma-separated
        row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';
    // str += row  ;

    for (let i = 0; i < array.length; i++) {
        let line = '';
        for (let index in array[i]) {
            if (line != '') line += ',';
            line += array[i][index];
        }
        str += line + '\r\n';
        // str += line ;
    }
    return str;
  }

  ConvertToCSVDynamically(objArray) {
    // alert("array for csv conversion " + JSON.stringify(objArray));
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = "";
    for (let index in objArray[0]) {
        //Now convert each value to string and comma-separated
        row += index.split("~")[0] + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';
    // str += row  ;

    for (let i = 0; i < array.length; i++) {
        let line = '';
        for (let index in array[i]) {
            if (line != '') line += ',';
            line += array[i][index];
        }
        str += line + '\r\n';
        // str += line ;
    }
    return str;

  }

  genrateOrderFromConfirmOrderPage(status, shippingCharges, customerOrderNumber, shippingServiceValue, tax,firstName,lastName){
    //alert(JSON.stringify(CART));
    let total = 0;
    let orderProducts = [];
    let expectedShipmentDate = CART.shipDate;
    let customPricing = false
    for(let item of CART.items){

      if(item.customPricing){
        console.log("CUTTTTSSSSSSOOOO " + item.selectedCustomPrice)
        item.price = item.selectedCustomPrice
        customPricing = true
      }

      if(this.discountCheck(item.discountPrice)){
        total =  total + (Number(item.discountPrice) * Number(item.quantity));
      }else{
        total =  total + (Number(item.price) * Number(item.quantity));
      }

      var orderDetailDTOs: any = {

        "productsDTO":item,
        "quantity": item.quantity,
        "expectedShipmentDate": expectedShipmentDate,
        "attributeSearch":item.attributeSearch
      };

      orderProducts.push(orderDetailDTOs);
    }

    if(CART.customer.locationsDTOs.length>0){
      for(let locationId in CART.customer.locationsDTO){
        CART.customer.locationsDTO[locationId].createdAt = "";
        CART.customer.locationsDTO[locationId].updatedAt = "";
      }
    }

    CART.customer.customerJson = "";
    let sendMailTo = [];
    sendMailTo.push(this.getLoggedInUserEmail() + "-supplier");

    let shippingService = shippingServiceValue.split("-");
    let orderShippingServiceName = shippingService[0]

    let orderShippingServiceValue = ""

    if(shippingService[1] !== undefined && shippingService[1] !== null)
      orderShippingServiceValue = shippingService[1]

    let order = {
      "id":CART.orderId,
      "orderTitle": this.getOrderTitle(),
      "salesManId":CART.user.id,
      "orderMessage":CART.orderMessage,
      "expectedShipmentDate": CART.expectedShipmentDate,
      "totalAmount":""+total.toFixed(2),
      "totalTexAmount":tax,
      "shippingCost" : shippingCharges,
      "orderStatus":status,
      "customerDTO":CART.customer,
      "customerOrderNumber" : customerOrderNumber,
      "orderDetailDTOs": orderProducts,
      "shippingServiceName":orderShippingServiceName,
      // "shippingServiceValue":CART.shippingServiceId,
      "shippingServiceValue":orderShippingServiceValue,
      "sendMailTo" : sendMailTo,
      "salesChannel" : "B2B Sales Rep",
      "paymentType"  : "cod",
      "orderBy" : firstName + " " + lastName
    };
    //this.gVLogger.log(JSON.stringify(order));

    // if(customPricing)
    //   order.orderMessage = order.orderMessage + " Custom Pricing allowed"
    return order;

  }

  addProductToCart(product) {

    var index= CART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {

      if (Number(product.minOrder) != 0 && product.multipleOfMinimumOrderFlag === 1) {
        CART.items[index].quantity += Number(product.minOrder);
      } else {
        CART.items[index].quantity++;
      }

      // CART.items[index].quantity++;
      this.persistOrderLocal();
    } else {

      // if((Constants.IntelliStockRunningIn === "BROWSER" || Constants.IntelliStockRunningIn === "APP") && product.productType === 1){
      //   product.quantity = product.qtyONHAND;
      //   // alert("quantity.. " + product.quantity + " productType " + product.productType + " constant " + Constants.IntelliStockRunningIn);
      // }
      // else{
      // alert("else");
      if (Number(product.minOrder) != 0) {
        product.quantity = Number(product.minOrder);
      } else {
        product.quantity = 1;
      }
      // }
      this.addToCartNew(product);
    }
    //alert(JSON.stringify(CART));
  }

  checkIfQuantityIsMultipleOfMinimumOrder(minimumQuantity, quantity){
    let modulus = quantity % minimumQuantity;
    if(modulus === 0 ){
      return quantity;
    }else {
      return quantity - modulus;
    }
  }

  // update Cart
  updateCartNew(product) {

    if(Number(product.minOrder) != 0 && product.multipleOfMinimumOrderFlag === 1 && Number(product.quantity) > Number(product.minOrder)){
      product.quantity = this.checkIfQuantityIsMultipleOfMinimumOrder(Number(product.minOrder),Number(product.quantity) )

    }else if(Number(product.quantity) < Number(product.minOrder)){
      if (Number(product.minOrder) != 0) {
        if (Number(product.quantity) < Number(product.minOrder)) {
          product.quantity = Number(product.minOrder);
        }
      } else {
        product.quantity = 1;
      }
    }


    var index= CART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      //CART.items[index].quantity++;
    } else {

      this.addToCartNew(product);
    }
    this.persistOrderLocal();
    //alert(JSON.stringify(CART));
  }
  // Remove One
  removeOneNew(product) {
    var index= CART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      if(product.multipleOfMinimumOrderFlag === 1 && CART.items[index].quantity > Number(product.minOrder)){
        CART.items[index].quantity -=  Number(product.minOrder)
      }
      else if(CART.items[index].quantity > Number(product.minOrder)){
        CART.items[index].quantity--;
        this.persistOrderLocal();
      }else{
        CART.items[index].quantity = 0;
        this.removeNew(index);

      }

    }
  }

  // Remove All
  removeAll(product) {
    var index= CART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      if(CART.items[index].quantity >= 1){
        CART.items[index].quantity = 0;
      }
    }
    this.persistOrderLocal();
  }


  // Remove Item
  removeNew(index: number): void {

    CART.items.splice(index, 1);
    this.persistOrderLocal();
  }

  addToCartNew(product) {
    // alert("product.productType : " + product.productType + " product.qtyONHAND : " + product.qtyONHAND + " product.quantity " + product.quantity);

    if(product.productType === 0){
      // alert("product.productType === 0");
      if(Number(product.minOrder)){
        if (Number(product.minOrder) != 0 && Number(product.quantity) < Number(product.minOrder)) {
          product.quantity = Number(product.minOrder);
        } else if(Number(product.quantity) > Number(product.minOrder)){

        }else{
          if(!Number(product.quantity)){
            product.quantiry = product.minOrder;
          }
        }
      }else if(!Number(product.minOrder)){
        if(Number(product.quantity)<=1){
          product.quantity = 1;
        }
      }

      CART.items.push(product);
      this.persistOrderLocal();

      let toast = this.toastCtrl.create({
        message: "Product added to cart!",
        duration: 2000,
        position: 'middle'
      });
      // toast.present();

    }else if(product.productType === 1 && product.qtyONHAND > 0){
      // if((Constants.IntelliStockRunningIn === "BROWSER" || Constants.IntelliStockRunningIn === "APP")){
      product.quantity = product.qtyONHAND;
      // alert("quantity.. " + product.quantity + " productType " + product.productType + " constant " + Constants.IntelliStockRunningIn);
      // }
      //   else{
      //   // alert("product.productType === 1 && product.qtyONHAND > 0");
      //   if(Number(product.minOrder)){
      //     if (Number(product.minOrder) != 0 && Number(product.quantity) < Number(product.minOrder)) {
      //       product.quantity = Number(product.minOrder);
      //     } else if(Number(product.quantity) > Number(product.minOrder)){

      //     }else{
      //        if(!Number(product.quantity)){
      //          product.quantiry = product.minOrder;
      //        }
      //     }
      //   }else if(!Number(product.minOrder)){
      //     if(Number(product.quantity)<=1){
      //       product.quantity = 1;
      //     }
      //   }
      // }
      CART.items.push(product);
      this.persistOrderLocal();

      let toast = this.toastCtrl.create({
        message: "Product added to cart!",
        duration: 2000,
        position: 'middle'
      });
      // toast.present();

    }else{
      let toast = this.toastCtrl.create({
        message: "This product is not available in inventory!",
        duration: 2000,
        position: 'middle'
      });
      toast.present();
    }

    //  if(Number(product.minOrder)){
    //   if (Number(product.minOrder) != 0 && Number(product.quantity) < Number(product.minOrder)) {
    //     product.quantity = Number(product.minOrder);
    //   } else if(Number(product.quantity) > Number(product.minOrder)){

    //   }else{
    //      if(!Number(product.quantity)){
    //        product.quantiry = product.minOrder;
    //      }
    //   }
    // }else if(!Number(product.minOrder)){
    //   if(Number(product.quantity)<=1){
    //     product.quantity = 1;
    //   }
    // }

    // CART.items.push(product);
    // this.persistOrderLocal();
  }
}



// WEBPACK FOOTER //
// ./src/providers/cart-manager.ts